export const environment = {
  baseUrl: 'https://devlmsgw.vemoit.com',
  production: false,
  urlName: 'devlmsdash.vemoit.com',
  urlLogout: 'https://devlmsgw.vemoit.com/logout?redirect_uri=https://devlmsgw.vemoit.com/login',
  apiurluber: 'https://devlmsgw.vemoit.com/bff-dashboard/uber/login?applicationId=',
  orbio_base_url: 'https://pre.eu.orbio.work',
};
